import api from '../utils/api';

const admissionsService = {
  listApplicants: async (status) => {
    try {
      return await api.get('/api/admissions/applicants', { params: { status } });
    } catch (error) {
      console.error('Error fetching applicants:', error);
      throw error;
    }
  },

  createApplicant: async (data) => {
    try {
      return await api.post('/api/admissions/applicants', data);
    } catch (error) {
      console.error('Error creating applicant:', error);
      throw error;
    }
  },

  getApplicant: async (applicantId) => {
    try {
      return await api.get(`/api/admissions/applicants/${applicantId}`);
    } catch (error) {
      console.error('Error fetching applicant:', error);
      throw error;
    }
  },

  updateApplicant: async (applicantId, data) => {
    try {
      return await api.put(`/api/admissions/applicants/${applicantId}`, data);
    } catch (error) {
      console.error('Error updating applicant:', error);
      throw error;
    }
  },

  deleteApplicant: async (applicantId) => {
    try {
      return await api.delete(`/api/admissions/applicants/${applicantId}`);
    } catch (error) {
      console.error('Error deleting applicant:', error);
      throw error;
    }
  },

  convertApplicant: async (applicantId, data) => {
    try {
      return await api.post(`/api/admissions/applicants/${applicantId}/convert`, data);
    } catch (error) {
      console.error('Error converting applicant:', error);
      throw error;
    }
  },

  listApplicantDocuments: async (applicantId) => {
    try {
      return await api.get(`/api/admissions/applicants/${applicantId}/documents`);
    } catch (error) {
      console.error('Error fetching applicant documents:', error);
      throw error;
    }
  },
  changeStage: async (applicantId, data) => api.post(`/api/admissions/enterprise/applicants/${applicantId}/stage`, data),
  stageHistory: async (applicantId) => api.get(`/api/admissions/enterprise/applicants/${applicantId}/stage-history`),
  waitlist: async () => api.get('/api/admissions/enterprise/waitlist'),
  promoteFromWaitlist: async applicantId => api.post(`/api/admissions/enterprise/waitlist/${applicantId}/promote`),
  reorderWaitlist: async (applicantId, newRank) => api.post(`/api/admissions/enterprise/waitlist/${applicantId}/reorder`, { new_rank: newRank }),
  interviews: async () => api.get('/api/admissions/enterprise/interviews'),
  createInterview: async data => api.post('/api/admissions/enterprise/interviews', data),
  updateInterview: async (id, data) => api.patch(`/api/admissions/enterprise/interviews/${id}`, data),
  offers: async () => api.get('/api/admissions/enterprise/offers'),
  createOffer: async data => api.post('/api/admissions/enterprise/offers', data),
  updateOffer: async (id, data) => api.patch(`/api/admissions/enterprise/offers/${id}/status`, data),
  deposits: async () => api.get('/api/admissions/enterprise/deposits'),
  createDeposit: async data => api.post('/api/admissions/enterprise/deposits', data),
  payDeposit: async (id, data) => api.post(`/api/admissions/enterprise/deposits/${id}/payments`, data),
  waiveDeposit: async (id, data) => api.patch(`/api/admissions/enterprise/deposits/${id}/waive`, data),
  verifyDocument: async (id, status, notes) => api.patch(`/api/admissions/enterprise/documents/${id}/verification`, null, { params: { status, notes } }),
  analytics: async () => api.get('/api/admissions/enterprise/analytics'),
  examResults: async applicantId => api.get('/api/admissions/enterprise/exam-results', { params: applicantId ? { applicant_id: applicantId } : {} }),
  createExamResult: async data => api.post('/api/admissions/enterprise/exam-results', data),
  listReviews: async applicantId => api.get(`/api/admissions/enterprise/applicants/${applicantId}/reviews`),
  createReview: async (applicantId, data) => api.post(`/api/admissions/enterprise/applicants/${applicantId}/reviews`, data),
};

export default admissionsService;
